import en from './en';
import br from './br';
import es from './es';

export default {
    en,
    br,
    es
};
